module.exports = (__parcel__import__("4K44c")).then(() => parcelRequire('2ipug'));